"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SigHelper__factory", {
  enumerable: true,
  get: function get() {
    return _SigHelper__factory.SigHelper__factory;
  }
});
Object.defineProperty(exports, "TDocDeployer__factory", {
  enumerable: true,
  get: function get() {
    return _TDocDeployer__factory.TDocDeployer__factory;
  }
});
var _SigHelper__factory = require("./SigHelper__factory");
var _TDocDeployer__factory = require("./TDocDeployer__factory");